import React from 'react';
import { MenuItem, Select, Typography } from '@mui/material';
import { getPageSelectOptions } from './getPageSelectOptions';

export default function PageSelect({
  pages = [],
  placeholder = 'Select page',
  disablePlaceholder = false,
  error,
  sx,
  ...field
}) {
  const pageOptions = getPageSelectOptions(pages);

  return (
    <>
      <Select size="small" displayEmpty sx={sx} {...field} error={Boolean(error)}>
        <MenuItem value="" disabled={disablePlaceholder}>
          {placeholder}
        </MenuItem>
        {pageOptions.map((p) => (
          <MenuItem key={p.value} value={p.value}>
            {p.label}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <Typography variant="caption" color="error">
          {error.message}
        </Typography>
      )}
    </>
  );
}
